import template from './component.tpl.html';
import AlGuestlistEditorComponentController from './controller';

/** Include sub components */
// import './pages/emails/component';
import './pages/fields/component';
import './pages/general/component';
// import './pages/form/component';
import './pages/general/component';
import './pages/notifications/component';
// import './pages/landing/component';
import './pages/online-checkin/component';
import './pages/limits/component';
// import './pages/tickets/component';
import './general/form-field-selector/component';
import './general/limit-configurator/component';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-editor guestlist="{}"></al-guestlist-editor>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistEditor', {
        bindings: {
            guestlist: '<',
            onModelUpdate: '&',
            onContactCustomFieldUpdate: '&',
            externalViewTrigger: '<'
        },
        controller: AlGuestlistEditorComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/component.js